export default function getCanonicalUrl(protocol, url) {
  if (!url) {
    return `${protocol}//www.withlocals.com`;
  }

  if (url === '' || url === '/') {
    return `${protocol}//www.withlocals.com`;
  }

  if (url.slice(-1) === '/') {
    return `${protocol}//www.withlocals.com${url}`;
  }

  return `${protocol}//www.withlocals.com${url}/`;
}
